import React from 'react';
import './AuthComponent.css';
import Login from '../authentication/Login/Login';
import logo from '../../Images/logo1.png';

const AuthComponent = () => {
  return (
    <div className="auth-container">
      <div className="image-side">
        <div className="signupimage-side">
          {/* <img src={logo} alt="Logo" className="logo" /> */}
          <h2>Let’s make every call count.</h2>
          <p>Log in and bring your best voice</p>
          <h3>Your AI assistant is waiting to help</h3>
        </div>
      </div>
      <div className="form-side">
        <div className="form-wrapper">
          <Login />
        </div>
      </div>
      <div className="background-shapes">
        <span className="bubble b1"></span>
        <span className="triangle t1"></span>
        <span className="rectangle r1"></span>
        <span className="bubble b2"></span>
        <span className="triangle t2"></span>
        <span className="rectangle r2"></span>
        <span className="bubble b3"></span>
        <span className="triangle t3"></span>
        <span className="rectangle r3"></span>
        <span className="bubble b4"></span>
        <span className="triangle t4"></span>
        <span className="rectangle r4"></span>
        <span className="bubble b5"></span>
        <span className="triangle t5"></span>
        <span className="rectangle r5"></span>
        <span className="bubble b6"></span>
        <span className="triangle t6"></span>
        <span className="rectangle r6"></span>
      </div>
    </div>
  );
};

export default AuthComponent;